import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  GuidGenerator,
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { environment } from 'environments/environment';
import { ErrorDO } from './../../../BaseFramework/shared/models/error.model';
import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler';
//import { element } from 'protractor';
import { MMSClientDataPipe } from 'app/BaseFramework/shared/custom-pipes';


interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}

@Component({
  selector: 'app-insured-coverage-decision',
  templateUrl: './insured-coverage-decision.component.html',
  styleUrls: ['./insured-coverage-decision.component.scss'],
  providers: [MMSClientDataPipe]
})
export class InsuredCoverageDecisionComponent implements OnInit {
  _currentComponentName = 'InsuredCoverageDecisionComponent'

  tempInsuredList = [];
  REJECTEDDECISION = "REJECT"

  insuredCoverageDecisionForm: FormGroup
  INSUREDCOVERAGEDECISIONFORM = "insuredCoverageDecisionForm"
  environment
  extraValuePrefix
  currencyPipe
  ratedTypeCd: any;
  extraValue:any;
  showExtraHeadersInsideAccordion
  currencyPrefix = this.appMetadataHandler.baseCurrencyPREFIX;
  currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR
  }
  decisionLookup: any;

  extracValuePrefix(ratingTypeCd) {
    this.currencyPipe = ratingTypeCd == 'FLAT'
    if (ratingTypeCd == 'FLAT') {
      this.extraValuePrefix = this.appMetadataHandler.baseCurrencyPREFIX
    }
    else {
      this.extraValuePrefix = "%"
    }
  }
  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private guidGenerator: GuidGenerator,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private clientDataPipe: MMSClientDataPipe) {
    this.environment = environment
  }

  //Declaraions which might need developer input
  claimsInsuredCoverageDecisionForm: FormGroup
  CLAIMSINSUREDCOVERAGEDECISIONFORMNAME = "claimsInsuredCoverageDecisionForm"
  selectorOfThisComponent = 'app-insured-coverage-decision'
  parentEvent$

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE   
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() transactionState: string;

  _policyDecision: any;
  @Input() set policyDecision(value: any){
    if(value){
    this._policyDecision = value;
    }
  }

  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
    this.initializeCoverages(this._inputDataForEdit);
    
  };

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  UItoServerTransform(payload, response) {
    let DOName = this.commonUtilty.getDOName(payload)
    let coverageSpecificDecisionList = response.componentData.coverageSpecificDecisionList
    let insuredSpecificDecisionList = response.componentData.insuredSpecificDecisionList
    const coverageListNode = DOName.includes('case') ? 'caseCoverages' : 'proposalCoverages'
    const clientListNode = DOName.includes('case') ? 'caseClients' : 'proposalClients'
    if (payload && response && DOName && payload[DOName]) {
      payload[DOName][coverageListNode] = coverageSpecificDecisionList
      if (Array.isArray(payload[DOName][clientListNode]) && insuredSpecificDecisionList) {
        payload[DOName][clientListNode].forEach((cln, index) => {
          let targetData = insuredSpecificDecisionList.find(insuredDecision => cln.guid == insuredDecision.guid)
          if (targetData) {
            let merged = Object.assign({}, cln, targetData)
            payload[DOName][clientListNode][index] = this.commonUtilty.deepCopy(merged)
          }
        })
      }
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        // let validationResult = this.validateOutput(this.claimsInsuredCoverageDecisionForm)
        let validationResult = { isInvalid: false } // remove if any customized validations to be added.
        if (!validationResult.isInvalid) {
          let output = {
            coverageSpecificDecisionList: this.getCurrentCoverageWiseDecisionSnapshot(),
            insuredSpecificDecisionList: this.getInsuredSpecificDecisionSnapshot()
          }
          this.EmitComponentOutput(output)
        }
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }

  isdataValid
  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput = {
      isInvalid: null,
      errorDOs: []
    }
    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())
    if (!this.isdataValid) {
      let errorDO = new ErrorDO()
      errorDO.errorMsg = "Event date and Retype Event Date mismatch";
      errorDO.componentName = this.getCurrentComponentName();
      errorDO.fieldName = "Event Date"
    }

    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput
  }

  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    if (!Form.valid) {
      for (const i in Form.controls) {

        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(this.claimsInsuredCoverageDecisionForm.get(controlName), this.CLAIMSINSUREDCOVERAGEDECISIONFORMNAME)
        if (Form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError;
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    return invalidFields;
  }

  //Initializations
  lookupsToBind = ['manualAdjDecisionCd', 'decisionCd', 'manualUwDecisionCd', 'ReasonforUnderwritingDecisionCd','ReasonForRejectedDecision','uwDecisionCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  // Front end error list
  errorList: any = [];
  consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
    if (this._inputDataForEdit != null) {
      this.initializeCoverages(this._inputDataForEdit);
      this.setDecisionForInsureds(this._policyDecision);
    }
    this.subscribeToParentEvent()
    this.updateDecisionLookup(this._inputDataForEdit)
  }

  updateDecisionLookup(payload){
    if (payload && payload.proposalDO) {
      this.decisionLookup = 'uwDecisionCd';
    } else {
      this.decisionLookup = 'manualUwDecisionCd';
    }
  }


  /**
   * Form Trasactions
   */

  FormFieldNameMap = {
    eventType: "Event Type",
    eventDate: "Event Date",
    retypeEventDate: "Retype Event Date",
    eventTime: "Event Time",
    retypeEventTime: "Retype Time",
    causeOfDeath: "Cause of Death",
    intimationDt: "Intimation Date",
    receivedDt: "Received Date",
  }

  initializeExtraPremiumAndRateChangeForm(data?) {
    let payload = data || {}
    this.claimsInsuredCoverageDecisionForm = this.fb.group({
      eventType: this.validationUtilService.setValidationsForFormControl('eventType', this.CLAIMSINSUREDCOVERAGEDECISIONFORMNAME, payload['eventType']),
    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.CLAIMSINSUREDCOVERAGEDECISIONFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }



  @Input() IO: any;

  coverageList = []
  popupDataPoints = {
    coverage: null,
    clientRefGuid: null,
    coverageInsured: null,
    tabIndex: null
  }

  emptyPopupDataPoints = {
    coverage: null,
    clientRefGuid: null,
    coverageInsured: null,
    tabIndex: null
  }

  setPopupDataPoints(coverage, clientRefGuid, coverageInsured, tabIndex?) {
    this.popupDataPoints.clientRefGuid = clientRefGuid;
    this.popupDataPoints.coverage = this.commonUtilty.deepCopy(coverage);
    if (coverage.hasOwnProperty('caseCoverageSchedules'))
      this.popupDataPoints.coverage.caseCoverageSchedules = coverage.caseCoverageSchedules.map(coverageSchedule => {
        coverageSchedule['oldRate'] = coverageSchedule['premiumRate']
        return coverageSchedule
      })
    if (coverage.hasOwnProperty('proposalCoverageSchedules'))
      this.popupDataPoints.coverage.proposalCoverageSchedules = coverage.proposalCoverageSchedules.map(coverageSchedule => {
        coverageSchedule['oldRate'] = coverageSchedule['premiumRate']
        return coverageSchedule
      })
    this.popupDataPoints.coverageInsured = this.commonUtilty.deepCopy(coverageInsured);
    this.popupDataPoints.tabIndex = parseInt(tabIndex)

    return this.popupDataPoints
  }

  modExclusionsAndRateChange
  isLoadingPopupData
  dataBindingInProgress
  currentsumInsuredAmt = 0;
  revisedSumAssured = 0
  currentIndex = 0;
  openAddMoreDataPopup(coverage, clientRefGuid, coverageInsured, tabIndex? , index?,action?,i?) {
    this.ratedTypeCd = null
    this.extraValue = null
    this.extraValuePrefix = null
    // this.isLoadingPopupData = true
    this.modExclusionsAndRateChange = true
    this.dataBindingInProgress = this.modExclusionsAndRateChange
    // let datapoints = this.setPopupDataPoints(coverage, clientRefGuid, coverageInsured, tabIndex)
    // if (datapoints.coverage && datapoints.clientRefGuid) {
    //   this.dataBindingInProgress = false
    // }
    setTimeout(() => {
      let datapoints = this.setPopupDataPoints(coverage, clientRefGuid, coverageInsured, tabIndex)
      if (datapoints.coverage && datapoints.clientRefGuid) {
        this.dataBindingInProgress = false
      }
      else {
        this.dataBindingInProgress = false
        this.modExclusionsAndRateChange = false
      }
    }, 100);

    if(coverageInsured.uwDecisionCd=='RATED' && this.loadingMethod && this.loadingPercent && this.commonUtilty.isArrayIterable(this.loadingMethod) && this.loadingMethod.length && this.commonUtilty.isArrayIterable(this.loadingPercent) && this.loadingPercent.length && this.loadingPercent[index] && this.loadingMethod[index]){
      this.ratedTypeCd = this.loadingMethod[index];
      this.extraValue = this.loadingPercent[index];
      this.currentIndex = index;
    }
    else {
        this.ratedTypeCd = null
        this.extraValue = null
        this.currentIndex = index;
    }
    if(action){
      this.selectAction(action, i)
    }
  }
  selectedAction = []
  selectAction(action, i){
    this.selectedAction[i] = action
    // this.selectedAction = this.selectedAction.filter(element => element !== action);
    // this.previousSelectedAction = this.selectedAction;
    if(this.commonUtilty.isArrayIterable(this.coverageList)){
          this.coverageList.forEach((ele, i)=>{
            ele.additionalField1 = this.selectedAction[i]
          })
    }
  }

  closeAddMoreDataPopup(ratedType?, extraValue?) {
    this.modExclusionsAndRateChange = false
    let caseCoverageLoadings = []
    if(ratedType && extraValue){
      this.loadingMethod[this.currentIndex] = ratedType;
      this.loadingPercent[this.currentIndex] = extraValue;
    }
    else {
      this.loadingMethod[this.currentIndex] = null;
      this.loadingPercent[this.currentIndex] = null;
    }
    if(ratedType && extraValue && !this.commonUtilty.isArrayIterable(caseCoverageLoadings)){
      caseCoverageLoadings = [{methodCd: ratedType, value: extraValue}];
      console.log(caseCoverageLoadings);
    }
    else if(this.commonUtilty.isArrayIterable(caseCoverageLoadings)){
      caseCoverageLoadings.forEach(item=>{
        item.methodCd = ratedType;
        item.value = extraValue;
      })
    }
    else{
      caseCoverageLoadings.forEach(item=>{
        item.value = null;
      })
    }

    if(this.commonUtilty.isArrayIterable(this.coverageList)){
      this.coverageList.forEach((c, i)=>{
        if (c.guid == this.popupDataPoints.coverage.guid && !this.commonUtilty.isArrayIterable(c.caseCoverageLoadings)
        && this.commonUtilty.isArrayIterable(caseCoverageLoadings)){
           c.caseCoverageLoadings =  this.commonUtilty.deepCopy(caseCoverageLoadings)
        }
        else if(c.guid == this.popupDataPoints.coverage.guid && this.commonUtilty.isArrayIterable(c.caseCoverageLoadings)
        && this.commonUtilty.isArrayIterable(caseCoverageLoadings)){
          c.caseCoverageLoadings = this.commonUtilty.deepCopy(caseCoverageLoadings)
        }
        if(c.guid == this.popupDataPoints.coverage.guid && this.revisedSumAssured){
          c.approvedSumInsuredAmt = this.commonUtilty.deepCopy(this.popupDataPoints.coverage.sumInsuredAmt)
          c.sumInsuredAmt = this.revisedSumAssured;
          // c.approvedSumInsuredAmt = this.commonUtilty.deepCopy(this.popupDataPoints.coverage.sumInsuredAmt)
          this.popupDataPoints.coverage.sumInsuredAmt = this.revisedSumAssured;
        }
      })
    }

    // this.coverageList.forEach((c, i) => {
    //   if (c.guid == this.popupDataPoints.coverage.guid) {
    //     this.coverageList[i] = this.commonUtilty.deepCopy(this.popupDataPoints.coverage)
        // if(ratedType && !this.coverageList[i]['caseCoverageLoadings'][i]['methodCd']){
        //   this.coverageList[i]['caseCoverageLoadings'][i]['methodCd'] = ratedType
        // }
        // else {
        //   this.coverageList[i]['caseCoverageLoadings'][i]['methodCd'] = ratedType
        // }
        // if(extraValue && !this.coverageList[i]['caseCoverageLoadings'][i]['value']){
        //   this.coverageList[i]['caseCoverageLoadings'][i]['value'] = extraValue
        // }
        // else {
        //   this.coverageList[i]['caseCoverageLoadings'][i]['value'] = extraValue
        // }
      //   if(this.coverageList[i] && !this.coverageList[i]['caseCoverageLoadings'] && this.commonUtilty.isArrayIterable(caseCoverageLoadings)){
      //     this.coverageList[i]['caseCoverageLoadings'] = this.commonUtilty.deepCopy(caseCoverageLoadings);
      //     console.log(this.coverageList[i]['caseCoverageLoadings']);
      //   }
      // }
    // })

    this.popupDataPoints = this.commonUtilty.deepCopy(this.emptyPopupDataPoints)
  }

  UICoverageInsuredNodeName = "coverageInsuredListMap"


  currencyCd: string = "";
  showCoverageTable: boolean = false;
  loadingPercent: any = [];
  loadingMethod : any = [];
  private initializeCoverages(IO) {
    if (IO) {
      this.tempInsuredList = this.getAllInsuredsFromIO(IO);
      let DO = this.commonUtilty.getDO(IO);
      this.currencyCd = IO[DO] && IO[DO]['currencyCd'] ? IO[DO]['currencyCd'] : '';
      this.coverageList = this.commonUtilty.deepCopy(DO['caseCoverages']) || this.commonUtilty.deepCopy(DO['proposalCoverages']) || [];
      this.coverageList.forEach((coverage,i) => {
        this.selectedAction[i] = coverage.additionalField1 ? coverage.additionalField1 : null;
        let coverageInsuredList = coverage['caseCoverageInsureds'] || coverage['proposalCoverageInsureds']
        if(this.commonUtilty.isArrayIterable(coverage['caseCoverageLoadings'])){
          coverage['caseCoverageLoadings'].forEach(item=>{
            if(item.value){
              // coverage[this.]
              this.loadingPercent[i] = item.value;
              this.loadingMethod[i] = item.methodCd
            }
          })
        }
        if(this.commonUtilty.isArrayIterable(coverage['proposalCoverageInsuredLoadings'])){
          coverage['proposalCoverageInsuredLoadings'].forEach(item=>{
            if(item.value){
              this.loadingPercent[i] = item.value;
              this.loadingMethod[i] = item.methodCd
            }
          })
        }
        coverage[this.UICoverageInsuredNodeName] = this.commonUtilty.convertArrayToMap(coverageInsuredList, 'clientRefGuid');
        if((coverage.planTypeCd == 'RIDER' || coverage.planTypeCd == 'BASEPLAN') && Object.keys(coverage[this.UICoverageInsuredNodeName]).length > 0){
          this.showCoverageTable = true;
        }
        coverage['coverageType'] = coverage.planTypeCd == "BASEPLAN" ? coverage.planTypeCd : coverage.planTypeCd == "RIDER" && coverage.associationType == "MANDATORY" ? 'Rider' : 'Add-on';
      });
    }
  }

  getInsuredSpecificDecisionSnapshot() {
    let output = []
    if (this.commonUtilty.isArrayIterable(this.tempInsuredList)) {
      this.tempInsuredList.forEach(insured => {
        let policyOrCaseClient = this.commonUtilty.deepCopy(insured['policyOrCaseClient'])
        output.push(policyOrCaseClient)
      })
    }
    return output
  }

  getCurrentCoverageWiseDecisionSnapshot() {
    let output = this.commonUtilty.deepCopy(this.coverageList)
    output.forEach(coverage => {
      let coverageInsuredListName = coverage['caseCoverageInsureds'] ? 'caseCoverageInsureds' : 'proposalCoverageInsureds'
      coverage[coverageInsuredListName] = this.commonUtilty.convertMapToArray(coverage[this.UICoverageInsuredNodeName]);
    });
    return output
  }

  exclusionList = []

  getAllInsuredsFromIO(IO) {
    let output = []
    let DOName = this.commonUtilty.getDOName(IO)
    let policyOrCaseClient = IO[DOName] ? IO[DOName]['caseClients'] ? IO[DOName]['caseClients'] : IO[DOName]['proposalClients'] ? IO[DOName]['proposalClients'] : null : null
    // let policyOrCaseClient = IO[DOName] ? IO[DOName]['caseClients'] : null
    if (IO) {
      let PRIMARYINSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
      let INSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'INSURED');
      if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
        output.push(...PRIMARYINSUREDLIST);
      if (INSUREDLIST && Array.isArray(INSUREDLIST))
        output.push(...INSUREDLIST)

      if (this.commonUtilty.isArrayIterable(policyOrCaseClient)) {
        output.forEach(cl => {
          let foundPolicyCaseClient = policyOrCaseClient.find(element => element.clientRefGuid == cl.guid)
          if (foundPolicyCaseClient) {
            cl['policyOrCaseClient'] = this.commonUtilty.deepCopy(foundPolicyCaseClient)
          }
          else {
            console.warn("Issue in Client: ", cl)
            throw `No Policy/Case Client found for Client - ${this.clientDataPipe.transform(cl, 'fullName')}`;
          }
        })
      }
    }
    return output
  }

  initializeInsuredCoverageDecisionForm(data?) {
    this.insuredCoverageDecisionForm = this.fb.group({});
  }

  setDecisionForInsureds(policyDecision) {
    let DOName = this.commonUtilty.getDOName(this._inputDataForEdit)
    if (this.commonUtilty.isArrayIterable(this.tempInsuredList) && policyDecision) {
      this.tempInsuredList.forEach(insured => {
        if (insured['policyOrCaseClient']) {
          insured['policyOrCaseClient']['uwDecisionCd'] = policyDecision == this.REJECTEDDECISION ? this.REJECTEDDECISION : null;
          insured['policyOrCaseClient']['decisionAllowed'] = policyDecision == this.REJECTEDDECISION ? false : true;
          this.setCoverageDecision(insured, policyDecision)
        }
      })
    }
    else if(this.commonUtilty.isArrayIterable(this.tempInsuredList) && this._inputDataForEdit){
      this.tempInsuredList.forEach(insured => {
        if (insured['policyOrCaseClient'] && this._inputDataForEdit[DOName] 
           && this.commonUtilty.isArrayIterable(this._inputDataForEdit[DOName].caseCoverages)) {


          this._inputDataForEdit[DOName].caseCoverages.forEach(item=>{
            if(item.primaryInsured && Object.keys(item.primaryInsured).length){
              if(insured['policyOrCaseClient'].clientRefGuid == item.primaryInsured.clientRefGuid){
                policyDecision = item.primaryInsured.uwDecisionCd
                insured['policyOrCaseClient']['uwDecisionCd'] = policyDecision;
                insured['policyOrCaseClient']['uwDecisionValue'] = item.primaryInsured.uwDecisionValue;
                this.setCoverageDecision(insured)
              }
            }
          })
        }
      //   else if (insured['policyOrCaseClient'] && this._inputDataForEdit[DOName] 
      //      && this.commonUtilty.isArrayIterable(this._inputDataForEdit[DOName].proposalCoverages)) {


      //     this._inputDataForEdit[DOName].proposalCoverages.forEach(item=>{
      //       if(item.primaryInsured && Object.keys(item.primaryInsured).length){
      //         if(insured['policyOrCaseClient'].clientRefGuid == item.primaryInsured.clientRefGuid){
      //           policyDecision = item.primaryInsured.uwDecisionCd
      //           insured['policyOrCaseClient']['uwDecisionCd'] = policyDecision;
      //           insured['policyOrCaseClient']['uwDecisionValue'] = item.primaryInsured.uwDecisionValue;
      //           this.setCoverageDecision(insured)
      //         }
      //       }
      //     })
      //   }
      })
    }
  }

  setCoverageDecision(insured, decision?) {
    if (insured && insured['policyOrCaseClient']) {
      if (this.commonUtilty.isArrayIterable(this.coverageList) && decision) {
        this.coverageList.forEach(coverage => {
          if (coverage['coverageInsuredListMap']) {
            for (const key in coverage['coverageInsuredListMap']) {
              if (insured['policyOrCaseClient'].clientRefGuid === coverage['coverageInsuredListMap'][key]['guid']) {
                coverage['coverageInsuredListMap'][key]['uwDecisionCd'] = decision == this.REJECTEDDECISION ? this.REJECTEDDECISION : null;
                coverage['coverageInsuredListMap'][key]['decisionAllowed'] = decision == this.REJECTEDDECISION ? false : true;
              }
            }
          }
        })
      }
      else if(this.commonUtilty.isArrayIterable(this.coverageList)){
        this.coverageList.forEach(coverage =>{
          if (coverage['coverageInsuredListMap'] && coverage.uwDecisionCd){
            for (const key in coverage['coverageInsuredListMap']) {
              if (insured['policyOrCaseClient'].clientRefGuid === coverage['coverageInsuredListMap'][key]['guid']){
                coverage['coverageInsuredListMap'][key].uwDecisionCd = coverage.uwDecisionCd;
              }
            }
          }
        })
      }
    }
  }

  setSelectedCoverageDecision(coverage, decision){
    if(coverage && decision && this.commonUtilty.isArrayIterable(this.coverageList)){
       this.coverageList.forEach(item=>{
        if(item.guid == coverage.guid){
          item.uwDecisionCd = decision;
        }
       })
    }
  }
}